import PropTypes from "prop-types"
import React from "react"
// import HeaderBg from "./HeaderBg"
import styled from "styled-components"
import HeaderContent from "./HeaderContent"
import HeaderBg from "../../images/pt-assets/prime-ira-bg.jpg"

const Header = () => (
  <Wrapper>
    <div className="container">
      <HeaderContent />
    </div>
  </Wrapper>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

const Wrapper = styled.header`
  background-image: url(${HeaderBg});
`

export default Header
